export default __webpack_public_path__ + "assets/img/Preloader.68c86e5c.gif";